import { makeStyles } from '@material-ui/core/styles'
import themesConfig from 'app/fuse-configs/themesConfig'

export default makeStyles(() => ({
  errorBar: {
    marginBottom: 82,
    backgroundColor: themesConfig.default.colors['orange-50'],
    padding: '12px 23px',
    boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.12)',
    fontSize: 14,
    lineHeight: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },

  error: {
    backgroundColor: themesConfig.default.colors['red-50'],
  },

  title: {
    fontWeight: 700,
    color: themesConfig.default.colors.primary,
  },

  description: {
    color: themesConfig.default.colors['dove-gray'],
  },
}))
